
























import { Component, Vue, Prop } from 'vue-property-decorator';
import pdf from 'vue-pdf';

@Component({
  components: { pdf }
})
export default class PdfjsViewer extends Vue {
  @Prop({ required: true }) fileUrl!: string;

  pageNum: number = 1;
  pageCount: number = 1;

  onNumPages(n: number) {
    this.pageCount = n;
  }

  prevPage() {
    if (this.pageNum > 1) this.pageNum--;
  }
  nextPage() {
    if (this.pageNum < this.pageCount) this.pageNum++;
  }

  showSecurityWarning(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    // this.$message && this.$message.warning('为保护文件安全，已禁用右键和复制');
    return false;
  }
}
